export { NameKeyForEdi } from './name-key-for-edi.component';
